import ShopifyVariantWCDEdit from './ShopifyVariantWCDEdit'

export default function ShopifyVariantWCDView({
    variant,
    product,
    fetchProduct,
}) {
    return (
        <div className="flex flex-col items-start gap-1 mt-3 text-sm">
            <span className="font-medium">WCD</span>
            <span>Jewels : {variant.wcd_jewels}</span>
            <span>Power : {variant.wcd_power}</span>
            <span>Strap : {variant.wcd_strap}</span>
            <span>Case : {variant.wcd_case}</span>

            <ShopifyVariantWCDEdit
                product={product}
                variant={variant}
                fetchProduct={fetchProduct}
            />
        </div>
    )
}